import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import StartpageGroupViewModelType from '@/ViewModels/Controls/StartpageGroupViewModel';
import LabelType from '@/Controls/Label';
import StartpageElementType from '@/Controls/StartpageElement';
import CustomStartpageElementRegistry from '@/Components/CustomStartpageElement/CustomStartpageElementRegistry';

export default class StartpageGroup extends Control {

    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private StartpageElement = ComponentManager.getControl<typeof StartpageElementType>('StartpageElement');
    private jQueryControl: JQuery;
    private elements: Array<StartpageElementType>
    private label: LabelType;

    public constructor(private viewModel: StartpageGroupViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="elements"></div></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'startpagegroup',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();

            tuple.control.prependTo(this.jQueryControl);
        }

        const elements = this.viewModel.elements();
        this.elements = [];

        for (const elementViewModel of elements) {
            const controlElement = $('<div>').appendTo(this.jQueryControl.find('.elements'));
            let element: StartpageElementType;
            if (elementViewModel.customElement) {
                const constructor = CustomStartpageElementRegistry.get(elementViewModel.customElement);
                element = new constructor(elementViewModel, controlElement, elementViewModel.customViewModel);
            } else {
                element = new this.StartpageElement(elementViewModel, controlElement);
            }

            const tuple = element.getTuple();

            this.elements.push(element);
        }
    }
}

ComponentManager.setControl('StartpageGroup', StartpageGroup, 'RADPresentation.HTMLClient.DefaultViewExtensions');